export const w_header_options = [
  { value: '', text: 'IDENTIFY' },
  { value: 'reference_designator', text: 'REF DESIGNATOR' },
  { value: 'mpn', text: 'MFG PART #' },
  { value: 'manufacturer', text: 'MFG (Optional) ' },
  { value: 'vendor_part', text: 'VENDOR PART' },
  { value: 'vendor', text: 'VENDOR (Optional) ' },
  { value: 'qty_per_board', text: 'QTY PER BOARD' },
  { value: 'description', text: 'DESCRIPTION (Optional) ' },
  { value: 'dnp', text: 'Do not populate?' },
];

export const w_title_options = [
  { value: 'reference_designator', text: 'reference designator' },
  { value: 'mpn', text: 'manufacturer part number' },
  { value: 'manufacturer', text: 'manufacturer' },
  { value: 'vendor_part', text: 'vendor part' },
  { value: 'vendor', text: 'vendor' },
  { value: 'qty_per_board', text: 'quantity per board' },
  { value: 'description', text: 'description' },
  { value: 'dnp', text: 'do not populate?' },
];
